module.exports = __webpack_public_path__ + "media/典型地物遥感影像特征.7f694871.mp4";